var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9998 14.0007C17.2215 14.0007 19.8332 11.389 19.8332 8.16732C19.8332 4.94566 17.2215 2.33398 13.9998 2.33398C10.7782 2.33398 8.1665 4.94566 8.1665 8.16732C8.1665 11.389 10.7782 14.0007 13.9998 14.0007Z",
    fill: "#938E8C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 16.916C8.15502 16.916 3.39502 20.836 3.39502 25.666C3.39502 25.9927 3.65169 26.2493 3.97835 26.2493H24.0217C24.3484 26.2493 24.605 25.9927 24.605 25.666C24.605 20.836 19.845 16.916 14 16.916Z",
    fill: "#938E8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.2c03dcb41d33d5cc1444e6e5a968409a.svg";
export { ForwardRef as ReactComponent };